import { FireWidgetLazy } from './fireWidgetLazy';

const props = [];

export const FireWidgetDirective = reactDirective => reactDirective(FireWidgetLazy, props);
FireWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('fireWidget', FireWidgetDirective);
